import axiosInstance from "../../plugins/axios-common";
import axios from "../../plugins/axios-common";

export default {
	actions: {
		fetchKKMStatus({commit}) {
			commit('kkmLoading', true)
			axios("/kkm/kkmstatus").then((res) => {
				const kkm = res.data
				commit('updateKKMStatus', kkm)
				commit('kkmLoading', false)
			}).catch(() => {
			this.dispatch('sendNotification', {quote: 'Нет связи с ККМ', type: 'danger'})
			})
		},
		openKKMShift({commit}) {
			commit('kkmLoading', true)
			const settings = {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axios("/kkm/openshift", settings).then((res) => {
				const kkmShift = res.data
				commit('updateKKMStatus', kkmShift)
				commit('kkmLoading', false)
			})
		},
		closeKKMShift({commit}) {
			commit('kkmLoading', true)
			const settings = {
				method: 'POST',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				}
			}
			axiosInstance("/kkm/closeshift", settings).then((res) => {
				const kkmShift = res.data
				commit('updateKKMStatus', kkmShift.results[0])
				commit('kkmLoading', false)
			}).catch((err) => {
				this.dispatch('sendNotification', {quote: `Ошибка закрытия смены ККМ (${err})`, type: 'danger'})
			})
		},
		// todo нужно или нет нигде ниразу не пользуется?
		// async sell({commit} , csrf) {
		// 	commit('kkmLoading', true)
		// 	const body = {
		// 		taxationType: 'osn',
		// 		operator: { name: "Иванов", vatin: "123654789507"},
		// 		items: [
		// 			{
		// 				type: "position",
		// 				name: "Бананы",
		// 				price: 73.15,
		// 				quantity: 1.0,
		// 				amount: 73.15,
		// 				tax: {
		// 					type: "vat18"
		// 				}
		// 			}]
		// 		,
		// 		payments:  [{
		// 			type: "cash",
		// 			sum: 73.15
		// 		}]
		// 	}
		// 	const settings = {
		// 		method: 'POST',
		// 		body: body,
		// 		headers: {
		// 			Accept: 'application/json',
		// 			'Content-Type': 'application/json',
		// 		}
		// 	}
		// 	axios("/kkm/sell", settings)
		// 	try {
		// 		const res = await fetch("/kkm/sell", settings)
		// 		const sell = await res.json()
		// 		commit('updateKKMSell', sell.results[0])
		// 	} catch (error) {
		// 		this.dispatch('sendNotification', {quote: 'Ошибка пробития чека на ККМ', type: 'danger'})
		// 		// console.log('error selling')
		// 	}
		// 	// setTimeout(dispatch('fetchKKMStatus'), 2000)
		// 	commit('kkmLoading', false)
		// }
	},
	mutations: {
		updateKKMStatus(state, kkm) {
			state.kkm = kkm
		},
		updateKKMSell(state, sell) {
			state.sell = sell
		},
		kkmLoading(state, loading) {
			state.kkmLoading = loading
		}
	},
	state: {
		kkmLoading: false,
		kkm: {},
		sell: {},
		kkmShiftStatus: ''
	},
	getters: {
		kkmData(state) {
			return state.kkm
		},
		kkmSell(state) {
			return state.sell
		},
		kkmLoading(state) {
			return state.kkmLoading
		},
		kkmShiftStatus(state) {
			if(state.kkm) {
				return state.kkm.result.shiftStatus.state
			}
		}
	},
}
